import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pesos',
  templateUrl: './pesos.component.html',
  styleUrls: ['./pesos.component.css']
})
export class PesosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
